<template>
 <div class="wrapper" id='container1'>  
  <CButton  color="info" @click="openCamera"><b>Scan QRCode</b></CButton>
  <CButton  color="info" @click="openFormField"><b>Form Field Data</b></CButton>
  <CRow class="mt-3">
    <CCol >
      <!-- <CButton color="info">
      <a href="#div-id" class="text-white" v-smooth-scroll="{ duration: 200, updateHistory: false }">Show Participant</a>
      <a href="#div-id" class="text-white" v-smooth-scroll="{ duration: 200 }">Show Participant</a>
      </CButton> -->
      <!-- <CButton color="info" @click="goto('div-id')">Show Participant</CButton> -->
      <!-- <CButton color="info" @click="cardCollapse = !cardCollapse">Show Participant</CButton> -->
      <CButton color="info" @click="show_attendance()">Show Participant</CButton>
      <CCard class="mt-3"  >
         <CButton
          @click="cardCollapse = !cardCollapse"
          tag="button"
          color="link" 
          block
          class="text-left shadow-none card-header"
        > 
           <b >Event's Detail </b>
         <b-iconstack  class="float-right mt-1" font-scale="1" rotate="90">
            <b-icon  v-show="!cardCollapse" icon="chevron-right" variant="primary"></b-icon>
            <b-icon   v-show="cardCollapse" class="float-right mt-1" font-scale="1" rotate="0" icon="chevron-left" variant="primary"></b-icon>

          </b-iconstack>
        </CButton>
        <CCollapse :show="cardCollapse">
        <CCardBody>
          <CRow>
            <CCol>
              <b> <label class="text-muted"> Status Event : {{ datas.data.status }}   </label> </b>
              <hr>
              <label> Category Event :  </label>
              <p > <b> {{ datas.data.category }} </b> </p> 
              <hr>
              <label> Event Name :  </label>
              <p >  <b> {{ datas.data.name }} </b> </p>
              <hr>
              <label> Available for :  </label>
              <p >  <b> {{ avail(datas.data.available) }} </b> </p>
              <hr>
              <label> Description Event :  </label>
              <p  > <b class="font-italic"> {{ datas.data.description }} </b> 
              <hr>
              <label> Date Event :  </label>
              <p  > <b class="font-italic"> {{ datas.data.datetime_event }} </b> 
              <hr>
              <label> Date Publish :  </label>
              <p  > <b class="font-italic"> {{ datas.data.datetime_publish }} </b> 
              <hr>
              <label> Location  :  </label>
              <p >  <b> {{ datas.data.location }} </b> </p>
              <hr>
              <label> Link  :  </label>
              <p >  <b> {{ datas.data.link }} </b> </p>
              <hr>

              <label> Price Ticket :  </label>
              <ul href="#" v-for="item in datas.data.event_tickets" :key="item.id">  
              <li>
              <CRow>
                <CCol   >
                  {{ item.name }} 
                </CCol>
              </CRow>
              <CRow>
                <CCol   >
                  <b>{{ 'Rp' }}  {{ item.price }}  </b>
                </CCol>
              </CRow>
              </li>
              </ul>  
              <hr> 
              <label> Payment Information :  </label>
              <ul href="#" v-for="item in payment" :key="item.id">  
              <li>
              <CRow>
                <CCol   >
                  {{ item.bank }} {{ " " }} {{ item.account }}
                </CCol>
              </CRow>
              </li>
              </ul> 
              <hr>

              <label> Ticket Information :  </label>
              <ul href="#" v-for="item in datas.ticket_info" :key="item.id">  
              <li>
              <CRow>
                <CCol   >
                  {{ item.name }} 
                </CCol>
              </CRow>
              <CRow>
                <CCol   >
                  <b>{{ 'quota: ' }}  {{ item.quota }}  </b>
                </CCol>
              </CRow>
              <CRow>
                <CCol   >
                  <b>{{ 'sisa tiket: ' }}  {{ item.sisa_tiket }}  </b>
                </CCol>
              </CRow>
              <CRow>
                <CCol   >
                  <b>{{ 'register: ' }}  {{ item.register }}  </b>
                </CCol>
              </CRow>
              <CRow>
                <CCol   >
                  <b>{{ 'hadir: ' }}  {{ item.hadir }}  </b>
                </CCol>
              </CRow>
              </li>
              </ul>  
              <hr> 
              <!-- <label> Max Ticket :  </label>
              <p > <b> {{ datas.data.ticket_max }} </b> </p>
              <hr> 
              <label> Total Participant :  </label>
              <p class="text-muted" >  <b> {{ "Total Participant" }} </b> </p> -->
            </CCol>
          </CRow>  
        </CCardBody>
          </CCollapse>
      </CCard>

<div id="div-id" ref="div-id">
      <CCard>
        
        <CCardBody>
          
          <div class="row">
              <div class="col-md-12">
                <div class="form-inline float-right mb-8">
                  <CButton color="danger" @click="cancel_participant()">Cancel Participant</CButton>
                </div>
                <h4 class="font-xl mb-3 " >Detail Participant </h4>
                  <div class="card">
                    
                      <div class="card-body">
                        
                          <Datatable 
                              :items="items" 
                              :fields="fields" 
                              :meta="meta" 
                              @per_page="handlePerPage" 
                              @pagination="handlePagination" 
                              @search="handleSearch" 
                              @sort="handleSort"
                              @is_active="handleIsActive"
                              :btn_show="true"
                              :btn_paid="true"
                              :btn_edit="true"
                              :btn_deactivate="true"
                              :btn_reactivate="false"
                              :btn_delete="false"
                              @show="handleShow"
                              @edit_att="handleEditAtt"
                              @attendance="handleAttendance"
                              @resendmail="handleResendmail"
                              @paid="handlePaid"
                              @editEvent="handleEditEvent"
                              @changeToPublish="handlechangeToPublish"
                              @showRegistrationPage="handleShowRegistrationPage"
                              @deactivate="handleDeactivate"
                              @reactivate="handleReactivate"
                          />
                      </div>
                  </div>
              </div>
          </div>           
        </CCardBody>
       
      </CCard>
       </div>
    </CCol>   
  </CRow>


  
<!-- {{ items }} -->
<!-- <pre>{{ $data | json }}</pre> -->

    <modalcancel></modalcancel>
    <alertmodal></alertmodal>
    
  </div>
</template>

<script>
import Datatable from '@/components/datatables_event_order.vue'

import alertmodal from '@/views/alert/modal.vue';
import event from '@/services/event'
import EventBus from '@/eventBus';
import store from '@/store.js';
import modalcancel from './event_cancel_participant';
import moment from 'moment';

export default {
  name: 'Dashboard',
  components: {
    Datatable,
    alertmodal,
    modalcancel
  },
  data () {
    return {
      mode:'',
      cardCollapse: true,
      datas:[],
      fields: [
          {key: 'booking_id', sortable: false, },
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false},
          //{key: 'total', sortable: false},
          {key: 'payment_status', sortable: false},
          {key: 'order_status', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      payment: [],
      meta: [],
      current_page: 1,
      per_page: 25,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
  },



  mounted(){
    this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

    

  },

  methods: {
     loadData(){
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }


        event.getEventbyID_withorder(this.$route.query.id, params)
        .then(res => {
            this.datas = res; 

          let getData = res.orders
          this.items = getData.data
          this.payment = JSON.parse(res.data.payment_information)
          //this.items = res.data.event_order
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }

        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
    },
    openShowOrderDetail(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-detail',
        query: {'id': id}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    openShowOrderAttendance(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-attendance',
        query: {'id': id, 'mode': 'create'}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    openShowOrderAttendanceEdit(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-attendance',
        query: {'id': id, 'mode': 'edit'}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    resendMail(id){
      if(confirm("Do you really want to resend mail?")){
        event.resendMailAttendance(id)
        .then(res => {
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      } 
    },
    openCamera: function () {
      //this.$router.push({name:'Event Camera', query: {id:this.$route.query.id} }) 
      this.$router.push({name:'Event Scan', query: {id:this.$route.query.id} }) 
    },

    openFormField: function () {
      let route = this.$router.resolve(
        {
          path: '/event_formfield_view',
          query: {
            'id': this.$route.query.id,
            'name': this.datas.data.name,
            'date': moment(this.datas.data.datetime_event).format("DD-MM-YYYY")
          }
        });
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(route.href, '_blank', "height=800,width=1000");
    },

    setAsPaid(id){
      if(confirm("Do you really want to set as PAID?")){
        event.setAsPaid(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },
      
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShowOrderDetail(val) 
    }, 
    handleEditAtt(val) {
        this.openShowOrderAttendanceEdit(val) 
    }, 
    handleAttendance(val) {
        this.openShowOrderAttendance(val) 
    }, 
    handleResendmail(val) {
        this.resendMail(val) 
    }, 
    handlePaid(val) {
        this.setAsPaid(val) 
    }, 
    handleEditEvent(val) {
        this.openEditEvent(val) 
    }, 
    handleShowRegistrationPage(val) {
        this.showRegistrationPage(val) 
    },    
    handlechangeToPublish(val) {
        this.changeToPublish(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

    avail(x){
      if(x == 'a'){x = 'Private'}
      else if(x == 'b'){x = 'ICare Coach'}
      else if(x == 'c'){x = 'ICL and Core Team'}
      else if(x == 'd'){x = 'Head of Department'}
      else if(x == 'e'){x = 'Volunter and Covenant'}
      else if(x == 'f'){x = 'Youth'}
      else if(x == 'g'){x = 'Everyone'}
      else{ x = '-' }
      return x
    },
  
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      //window.scrollTo(0, top);

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });

    },

    show_attendance: function(){ 

      let routeData = this.$router.resolve({path: '/event_detail_attendance',query: {id:this.$route.query.id} }) 
      window.open(routeData.href, '_blank');

    },

    cancel_participant: function(){ 
      //alert("a");
      var params = {title: 'Cancel Participant', mode:'edit',data:''}
      EventBus.$emit('OPEN_MODAL_EVENT_CANCEL_PARTICIPANT', params)
    },

  }
}
</script>
